// extracted by mini-css-extract-plugin
export default {"dogshowcard":"DogCardDogshow_dogshowcard__1t5TA","showstable":"DogCardDogshow_showstable__ipc3m"};